function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useContext, useState } from "react";
import { Body, Button, EntryAnimation } from "../../atoms";
import { Play } from "../../visuals";
import { VideoModal } from "../VideoModal";
import ReactConfigContext from "../../ReactConfigContext";
export default function MediaSection(param) {
    var image = param.image, label = param.label, video = param.video, className = param.className;
    var _useState = _sliced_to_array(useState(false), 2), videoOpen = _useState[0], setVideoOpen = _useState[1];
    var _useContext = useContext(ReactConfigContext), ImageComponent = _useContext.config.ImageComponent;
    var handleVideoClick = function() {
        setVideoOpen(true);
    };
    var handleVideoKeyDown = function(event) {
        if (event.key === " " || event.key === "Enter" || event.key === "Spacebar") {
            // Prevent the default action to stop scrolling when space is pressed
            event.preventDefault();
            setVideoOpen(true);
        }
    };
    var handleCloseModal = function() {
        setVideoOpen(false);
    };
    var _minwidth980px1200px100vw;
    return /*#__PURE__*/ React.createElement("div", {
        className: className
    }, /*#__PURE__*/ React.createElement(EntryAnimation, {
        className: "isolate grid grid-cols-1 grid-rows-1 mx-auto"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "col-start-1 row-start-1"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "rounded-xl overflow-auto safari-fix-transform"
    }, /*#__PURE__*/ React.createElement(ImageComponent, _object_spread_props(_object_spread({}, image), {
        sizes: (_minwidth980px1200px100vw = "(min-width: 980px) 1200px, 100vw") !== null && _minwidth980px1200px100vw !== void 0 ? _minwidth980px1200px100vw : image.sizes
    }))), !!label && /*#__PURE__*/ React.createElement("div", {
        className: "my-5 mx-4"
    }, /*#__PURE__*/ React.createElement(Body, {
        variant: "sm",
        className: "prose prose-neutral"
    }, label))), !!video && /*#__PURE__*/ React.createElement("div", {
        role: "button",
        tabIndex: 0,
        className: "col-start-1 row-start-1 z-10 flex items-center justify-center cursor-pointer",
        onClick: handleVideoClick,
        onKeyDown: handleVideoKeyDown
    }, /*#__PURE__*/ React.createElement(Button, {
        variant: "primary",
        type: "icon-only",
        icon: /*#__PURE__*/ React.createElement(Play, null),
        className: "py-4 px-4 [&_svg]:w-[3.5rem] [&_svg]:h-auto [&_svg]:translate-x-1"
    }))), !!video && /*#__PURE__*/ React.createElement(VideoModal, {
        url: video,
        open: videoOpen,
        onClose: handleCloseModal
    }));
}

//# sourceMappingURL=MediaBlock.js.map